import React, { useRef, useState } from 'react';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { useParams } from 'react-router-dom';

import '../../dropdown/dropdown.scss';
import '../filters.scss';
import './investorDropdownFilter.scss';
import useWidthToElement from '../../../../common/hooks/useWidthToElement';

interface IInvestorDropdown {
  onChangeCallback?: (event: DropDownListChangeEvent) => void;
  investors?: any;
}

const InvestorDropdownFilter: React.FC<IInvestorDropdown> = ({ onChangeCallback, investors }) => {
  const { investorId } = useParams();
  const [width, setWidth] = useState(0);
  const wrapperRef = useRef<any>();

  useWidthToElement(wrapperRef, setWidth);

  const returnDefaultInvestor = () => {
    if (investorId) {
      return investors.filter((investor) => investor.id === parseInt(investorId))[0];
    }
    return investors[0];
  };

  return (
    <div className="investor-dropdown-wrapper"
         ref={wrapperRef}
    >
      {investors &&
        <DropDownList
          style={{maxWidth: width}}
          data={investors}
          defaultValue={returnDefaultInvestor()}
          textField="name"
          dataItemKey="id"
          onChange={onChangeCallback} />}
    </div>
  );
};

export default InvestorDropdownFilter;
